// Import generator
import { GenerateGenericPreviewImage, GenerateBlankPreviewPlaceholderImage } from "./GenerateGenericPreviewImage";



// Export resolver
export const ResolveTemplatePreviewPayload = ({
    
    // This is the selected preview config
    previewConfig,
    
    // This is the logo url
    logoUrl,
    
}) => {
    
    // Guard missing config
    if (!previewConfig) {
        
        // Return safe empty payload
        return {
            imageDetails: null,
            uploadedImage: null,
        };
        
    }
    
    // Handle blank preview mode
    if (previewConfig?.sourceType === "none") {
        
        // Return a placeholder payload that still marks the role as used
        return GenerateBlankPreviewPlaceholderImage();
        
    }
    
    // Handle uploaded image mode
    if (previewConfig?.sourceType === "upload") {
        
        // Return uploaded payload directly
        return {
            ...(previewConfig?.uploadedImage || {}),
            previewMode: "upload",
            suppressProductPreview: false,
        };
        
    }
    
    // Handle logo mode
    if (previewConfig?.shape === "logo") {
        
        // Return logo payload
        return {
            imageDetails: {
                name: "software-logo",
                image_url: logoUrl,
            },
            uploadedImage: logoUrl,
            previewMode: "logo",
            suppressProductPreview: false,
        };
        
    }
    
    // Handle generic shape mode
    return {
        
        // Generate the selected generic preview shape
        ...GenerateGenericPreviewImage({
            
            // Pass the selected shape
            shape: previewConfig?.shape,
            
            // Pass the selected colour with a safe fallback
            fillColour: previewConfig?.fillColour || "#2563EB",
            
        }),
        
        // Mark this as a generic preview
        previewMode: "generic",
        
        // Allow the product preview to display
        suppressProductPreview: false,
        
    };
    
};
